import moment from "moment";

export const setFromDate = (dateFrom: Date) => {
  dateFrom.setHours(0);
  dateFrom.setMinutes(0);
  dateFrom.setSeconds(0);
  return dateFrom;
};

export const setToDate = (dateTo: Date) => {
  dateTo.setHours(23);
  dateTo.setMinutes(59);
  dateTo.setSeconds(59);
  return dateTo;
};

export const dateToEpoch = (date: Date): string => {
  return Math.floor(date.getTime() * 1000.0).toString();
}

export const getDays = (fromDate: Date, toDate: Date) => {
  return moment(fromDate).diff(toDate, 'days');
}

export const addDays = (date: Date, days: number) => {
  return moment(date).add(days, 'days').toDate();
}